import axios, { extractData, getAtheneumContactSuggestions } from '@atheneum/api'
import { computed, extendObservable } from 'mobx'


class ProjectsPipelineStore {
  constructor(atheneumOfficeStore) {
    const defaultAtheneumOffice = { id: '', name: 'All' }

    extendObservable(this, {
      atheneumOfficeStore,
      loading: false,
      error: null,
      projects: [],
      requestedSum: '',
      targetSum: '',
      deliveredSum: '',
      interviewedSum: '',
      revenueSum: '',
      costSum: '',
      totalMargin: '',
      query: this.getEmptyQuery(),
      selectedAtheneumContact: null,
      atheneumOffices: computed(() => {
        return [
          defaultAtheneumOffice,
          ...this.atheneumOfficeStore.atheneumOffices
        ]
      })
    })
  }

  getEmptyQuery() {
    return {
      atheneumContact: '',
      atheneumOffice: ''
    }
  }

  filter() {
    this.loading = true
    let url = '/api/project/projects-pipeline'
    if (this.query.atheneumContact) {
      url += `?atheneumContact=${this.query.atheneumContact}`
    }
    if (this.query.atheneumOffice) {
      url += `?atheneumOffice=${this.query.atheneumOffice}`
    }
    if (this.query.atheneumContact && this.query.atheneumOffice) {
      url += `?atheneumContact=${this.query.atheneumContact}&atheneumOffice=${this.query.atheneumOffice}`
    }
    return axios
      .get(url)
      .then(res => {
        const responseData = extractData(res)
        this.projects.replace(responseData.projects)
        this.requestedSum = responseData.requestedSum
        this.targetSum = responseData.targetSum
        this.deliveredSum = responseData.deliveredSum
        this.interviewedSum = responseData.interviewedSum
        this.revenueSum = responseData.revenueSum
        this.costSum = responseData.costSum
        this.totalMargin = responseData.totalMargin
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  autocompleteAtheneumContact = value => {
    if (!value) return Promise.resolve([])

    return getAtheneumContactSuggestions(value).then(result => {
      const autocompleteResult = result.rows.map(element => {
        const suggestion = {
          value: element.id,
          label: element.fullName
        }
        return suggestion
      })
      return autocompleteResult
    })
  }

  clearSearch() {
    this.query = this.getEmptyQuery()
    this.selectedAtheneumContact = null
    this.filter()
  }
}

export default ProjectsPipelineStore
